<div [cdkTrapFocus]="isActive">
    <button matFab
        class="fab-menu__primary-btn"
        [matTooltip]="extended"
        matTooltipPosition="left"
        aria-haspopup="menu"
        (click)="onClick_toggleMenu()">
        <mat-icon>{{icon}}</mat-icon>
    </button>

    @if (isActive) {
        <div class="fab-menu__actions" role="menu" [attr.aria-label]="extended">
            @for (button of actionButtons; track button) {
                <div class="fab-menu__action">
                    @if (button.label) {
                        <span class="fab-menu__action-label mat-elevation-z2">{{button.label}}</span>
                    }
                    @switch (button.actionType) {
                        @case (FabMenuActionType.Button) {
                            <button matMiniFab
                                (click)="button.action"
                                [attr.aria-label]="button.label">
                                <mat-icon>{{button.icon}}</mat-icon>
                            </button>
                        }
                        @case (FabMenuActionType.Anchor) {
                            <a matMiniFab
                                [routerLink]="button.action"
                                [attr.aria-label]="button.label">
                                <mat-icon>{{button.icon}}</mat-icon>
                            </a>
                        }
                    }
                </div>
            }
        </div>
    }
</div>
